import MathEngine from "../../utils/MathEngine"

export class Equation {
  constructor(eq = {}){    
    this.caption = eq.caption ? eq.caption : "",
    this.equation = eq.equation ? eq.equation : "",
    this.unit = eq.unit ? eq.unit : "",
    this.lastError = ''

    this.calc = function(mapping) {
      let result = -9999

      if(this.equation){
        let result;
        
        if(String(this.equation).trim().match(/^[*/\-+]/))
          result = MathEngine.sentence(mapping + " " + this.equation)
        else
          result = MathEngine.sentence(this.equation)

        this.lastError = result.result
        return result
      }
      else{
        result = MathEngine.sentence(mapping)
      }
      return result;
    }

    this.clone = function(){      
      return new Equation({...this})
    }

    this.getLastError = function() {
      return this.lastError()
    }
  }
}

const EquationRef = new Map()

EquationRef.set("W", new Equation())
EquationRef.set("WVol", new Equation())
EquationRef.set("P", new Equation())
EquationRef.set("T", new Equation())
EquationRef.set("POL", new Equation())
EquationRef.set("AR", new Equation())
EquationRef.set("ART", new Equation())
EquationRef.set("brix", new Equation())
EquationRef.set("pureza", new Equation())
EquationRef.set("pot", new Equation())

export default EquationRef